import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    LaneStatus, CollectionServiceType, DeliveryServiceType,
} from 'app/enums/label.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LanesQuotation,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.types'

const columns = ({
    l,
    laneLinkConfig,
}: {
    l: (l: string) => string,
    laneLinkConfig?: {
        path: string[],
        params?: Record<string, string>,
    }
}): RichTableColumns<keyof LanesQuotation>[] => {
    return [
        {
            id: 'laneNumber',
            headerProps: {
                children: l('AccountQuotes.lanes'),
            },
            mapCellProps: 'laneNumber',
            componentName: 'SkyNetTableLink',
            linkConfig: laneLinkConfig,
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
        },
        {
            id: 'laneGroupNumber',
            headerProps: {
                children: l('LaneGroup.laneGroupNumber'),
            },
            mapCellProps: 'laneGroupNumber',
        },
        {
            id: 'laneStatus',
            headerProps: {
                children: l('AccountQuotes.laneStatus'),
            },
            filterField: 'laneStatus',
            filterType: FilterType.Array,
            mapCellProps: 'laneStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneStatus,
        },
        {
            id: 'originAirport',
            headerProps: {
                children: l('AccountQuotes.laneFrom'),
            },
            filterField: 'originAirport',
            filterType: FilterType.Array,
            mapCellProps: 'originAirport',
        },
        {
            id: 'destinationAirport',
            headerProps: {
                children: l('AccountQuotes.laneTo'),
            },
            filterField: 'destinationAirport',
            filterType: FilterType.Array,
            mapCellProps: 'destinationAirport',
        },
        {
            id: 'deliveryServiceType',
            headerProps: {
                children: l('AccountQuotes.laneDeliveryType'),
            },
            mapCellProps: 'deliveryServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: DeliveryServiceType,
        },
        {
            id: 'collectionServiceType',
            headerProps: {
                children: l('AccountQuotes.laneCollectionType'),
            },
            mapCellProps: 'collectionServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: CollectionServiceType,
        },
        {
            id: 'changedBy',
            headerProps: {
                children: l('LaneGroup.changedBy'),
            },
            mapCellProps: 'changedBy',
        },
    ]
}

export default columns
